import React, { useEffect, useState, useCallback } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { GetUserInfo, UpdateUserInfo } from "../database/userInfo";
import "./shared.css";
import { getTranslations } from "../Shared/translations";

interface UserInfo {
  id: any;
  naam: string;
  voornaam: string;
  firma: string;
  straat: string;
  huisnummer: string;
  postcode: string;
  gemeente: string;
  land: string;
  telefoon: string;
  btw: string;
}

const initialState: UserInfo = {
  id: null,
  naam: "",
  voornaam: "",
  firma: "",
  straat: "",
  huisnummer: "",
  postcode: "",
  gemeente: "",
  land: "",
  telefoon: "",
  btw: "",
};

const Klantgegevens: React.FC = () => {
  const [userInfo, setUserInfo] = useState<UserInfo>(initialState);
const t = getTranslations();
  const getUser = useCallback(async () => {
    const data = await GetUserInfo();
    const fetchedUser = data.success;

    if (fetchedUser.naam !== userInfo.naam) {
      setUserInfo({
        id: fetchedUser.id,
        naam: fetchedUser.naam,
        voornaam: fetchedUser.voornaam,
        firma: fetchedUser.firma,
        straat: fetchedUser.straat,
        huisnummer: fetchedUser.huisnummer,
        postcode: fetchedUser.postcode,
        gemeente: fetchedUser.gemeente,
        land: fetchedUser.land,
        telefoon: fetchedUser.telefoon,
        btw: fetchedUser.btw,
      });
    }
  }, [userInfo.naam]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  const updateUser = async (info: UserInfo) => {
    const updated = await UpdateUserInfo(
      info.id,
      info.naam,
      info.voornaam,
      info.firma,
      info.straat,
      info.huisnummer,
      info.postcode,
      info.gemeente,
      info.land,
      info.telefoon,
      info.btw
    );
    console.log("User updated:", updated);
  };

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const updatedInfo: UserInfo = {
      id: formData.get("id"),
      naam: formData.get("naam") as string,
      voornaam: formData.get("voornaam") as string,
      firma: formData.get("firma") as string,
      straat: formData.get("straat") as string,
      huisnummer: formData.get("huisnummer") as string,
      postcode: formData.get("postcode") as string,
      gemeente: formData.get("gemeente") as string,
      land: formData.get("land") as string,
      telefoon: formData.get("telefoon") as string,
      btw: formData.get("btw") as string,
    };

    updateUser(updatedInfo);
  };

  return (
    <Form onSubmit={submitHandler} className="settings-form">
      <Form.Control type="hidden" defaultValue={userInfo.id} name="id" />

      <Row>
        <Col>
          <Form.Label className="form-label-primary">{t.naam}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.naam} name="naam" />
        </Col>
        <Col>
          <Form.Label className="form-label-primary">{t.voornaam}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.voornaam} name="voornaam" />
        </Col>
      </Row>

      <Row>
        <Col xs={8}>
          <Form.Label className="form-label-primary">{t.firma}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.firma} name="firma" />
        </Col>
        <Col xs={4}>
          <Form.Label className="form-label-primary">{t.land}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.land} name="land" />
        </Col>
      </Row>

      <Row>
        <Col>
          <Form.Label className="form-label-primary">{t.straat}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.straat} name="straat" />
        </Col>
        <Col xs={3}>
          <Form.Label className="form-label-primary">{t.huisnummer}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.huisnummer} name="huisnummer" />
        </Col>
      </Row>

      <Row>
        <Col xs={3}>
          <Form.Label className="form-label-primary">{t.postcode}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.postcode} name="postcode" />
        </Col>
        <Col>
          <Form.Label className="form-label-primary">{t.plaats}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.gemeente} name="gemeente" />
        </Col>
      </Row>

      <Row>
        <Col>
          <Form.Label className="form-label-primary">{t.telefoon}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.telefoon} name="telefoon" />
        </Col>
        <Col>
          <Form.Label className="form-label-primary">{t.btwnr}</Form.Label>
          <Form.Control type="text" defaultValue={userInfo.btw} name="btw" />
        </Col>
      </Row>

      <div className="settings-actions">
        <Button variant="primary" type="submit" className="btn-primary-app">
          {t.bewaar}
        </Button>
      </div>
    </Form>
  );
};

export default Klantgegevens;
